export const NoData = (props: { elementName: string }) => (
  <div className="no-data">No {props.elementName} found</div>
);
